import React, { useEffect } from 'react';
import './App.css';
import axios from 'axios';

import ServicePage from './pages/ServicePage';

function App() {
  useEffect(() => {
    axios.get('/api/ping', {});
  }, []);
  return <ServicePage />;
}

export default App; 